<template>
    <Container :slim="true">
        <div class="px-4 px-md-0 mb-3">
            <router-link :to="{name: domain ? 'home' : 'proposals'}" class="text-gray">
                <Icon name="back" size="22" class="v-align-middle" />
                {{ space.name }}
            </router-link>
        </div>
        <div>
            <div class="col-12 col-lg-8 float-left pr-0 pr-lg-5">
                <div class="px-4 px-md-0">
                    <div class="d-flex flex-column mb-6">
                        <div class="select-button">
                            {{ $t('page.tokenIds') }}
                            <UiButton class="button" @click="targetVisible = !targetVisible">
                                {{ selectId }}
                            </UiButton>
                            <div v-if="targetVisible" class="select">
                                <div
                                    :class="['select-item', tokenId === selectId ? 'active' : '']"
                                    @click="loadPower(tokenId)"
                                    v-for="(tokenId, index) in tokenIds"
                                    :key="index"
                                >
                                    {{ tokenId }}
                                </div>
                            </div>
                        </div>
                        <input
                            v-autofocus
                            v-model="name"
                            maxlength="128"
                            class="h1 mb-2 input"
                            :placeholder="$t('page.createTitle')"
                        />
                        <textarea-autosize
                            v-model="body"
                            maxlength="10240"
                            class="input pt-1 mb-6"
                            :placeholder="$t('page.body')"
                        />
                        <div v-if="body">
                            <h4 class="mb-4">Preview</h4>
                            <UiMarkdown :body="body" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4 float-left">
                <Block
                    :title="$t('page.action')"
                    :icon="space.network === '4' ? 'stars' : undefined"
                    @submit="modalPluginsOpen = true"
                >
                    <UiButton class="d-flex width-full mb-2" v-for="(data, i) in targets" :key="i">
                        <span class="mr-4">{{ i + 1 }}</span>
                        {{ signatures[i] }}
                        <span @click="removeTarget(i)" class="ml-4">
                            <Icon name="close" size="12" />
                        </span>
                    </UiButton>

                    <UiButton @click="modalOpen = true" class="button--submit width-full mb-2">
                        {{ $t('page.addAction') }}
                    </UiButton>
                    <UiButton
                        @click="handleSubmit"
                        :disabled="!isValid"
                        :loading="loading"
                        class="d-block width-full button--submit"
                    >
                        {{ $t('page.publish') }}
                    </UiButton>
                </Block>
            </div>
        </div>
        <ModalProposal
            :targets="targets"
            :values="values"
            :signatures="signatures"
            :calldatas="calldatas"
            :proposalParams="proposalParams"
            :open="modalOpen"
            :networkId="web3.network.chainId"
            @close="modalOpen = false"
        />
        <ModalProposalConfirm
            :form="form"
            :proposalParams="proposalParams"
            :open="confirmModalOpen"
            :networkId="web3.network.chainId"
            @close="confirmModalOpen = false"
        />
        <!-- <ModalSelectDate
      :value="form[selectedDate]"
      :selectedDate="selectedDate"
      :open="modalOpen"
      @close="modalOpen = false"
      @input="setDate"
    /> -->
        <!-- <ModalPlugins
      :proposal="{ ...form, choices }"
      :value="form.metadata.plugins"
      v-model="form.metadata.plugins"
      :open="modalPluginsOpen"
      @close="modalPluginsOpen = false"
    /> -->
    </Container>
</template>

<script>
import {mapActions} from 'vuex';
// import draggable from 'vuedraggable';
import {getBlockNumber} from '@/helpers/web3';
import getProvider from '@/helpers/provider';

export default {
    // components: {
    //   draggable
    // },
    data() {
        return {
            name: '',
            body: '',
            key: this.$route.params.key,
            loading: false,
            targets: [],
            values: [],
            signatures: [],
            calldatas: [],
            proposalParams: [],
            blockNumber: -1,
            params: {},
            scores: 0,
            latestProposalState: '',
            form: {
                contractType: 'Governor',
                contractAddress: '',
                action: 'propose',
                args: []
            },
            modalOpen: false,
            confirmModalOpen: false,
            modalPluginsOpen: false,
            selectedDate: '',
            counter: 0,
            targetVisible: false,
            tokenIds: [],
            selectId: null
        };
    },
    computed: {
        space() {
            const space = this.app.spaces[this.web3.network.chainId];
            return space || {};
        },
        isValid() {
            return (
                !this.loading &&
                this.web3.account &&
                this.name &&
                this.targets.length > 0 &&
                this.targets.length === this.values.length &&
                this.targets.length === this.signatures.length &&
                this.targets.length === this.calldatas.length
            );
        }
    },
    async mounted() {
        this.blockNumber = await getBlockNumber(getProvider(this.space.network));
        await this.loadData();
    },
    watch: {
        'web3.account': async function(val, prev) {
            if (val && val.toLowerCase() !== prev) {
                this.loading = true;
                await this.loadData();
                this.loading = false;
            }
        },
        'web3.network.chainId': async function(val, prev) {
            if (val.toString() !== prev.toString()) {
                this.loading = true;
                await this.loadData();
                this.loading = false;
            }
        }
    },
    methods: {
        ...mapActions([
            'send',
            'getLatestProposalIds',
            'getGovernorParams',
            'getPower',
            'getTokenIds',
            'getProposalState'
        ]),
        async loadData() {
            this.params = await this.getGovernorParams(this.space);
            await this.loadTokenIds();
            const id = await this.getLatestProposalIds(this.space);
            if (id > 0) {
                this.latestProposalState = await this.getProposalState({
                    space: this.space,
                    id
                });
            }
        },
        async loadTokenIds() {
            if (!this.web3.account) return;
            const ids = await this.getTokenIds({
                space: this.space,
                account: this.web3.account
            });
            this.tokenIds = ids || [];
            if (!this.selectId && ids.length > 0) await this.loadPower(ids[0]);
        },
        async loadPower(tokenId) {
            if (!this.web3.account) return;
            this.selectId = tokenId;
            const {scores} = await this.getPower({
                space: this.space,
                tokenId,
                blockNumber: null
            });
            this.scores = scores || [];
            this.targetVisible = false;
        },
        removeTarget(i) {
            this.targets.splice(i, 1);
            this.values.splice(i, 1);
            this.signatures.splice(i, 1);
            this.calldatas.splice(i, 1);
            this.proposalParams.splice(i, 1);
        },

        async handleSubmit() {
            if (!this.params || !this.params.proposalThreshold || !this.scores) {
                this.$store.dispatch('notify', ['red', `not contract data`]);
                return;
            }

            if (this.latestProposalState === 'Pending' || this.latestProposalState === 'Active') {
                this.$store.dispatch('notify', ['red', `already has a active or pending proposal`]);
                return;
            }

            if (parseFloat(this.scores[0]) < parseFloat(this.params.proposalThreshold)) {
                this.$store.dispatch('notify', [
                    'red',
                    `proposer votes below proposal threshold, min is ${parseFloat(
                        this.params.proposalThreshold
                    ).toFixed(2)} veGyro`
                ]);
                return;
            }

            this.form.key = this.key;
            this.form.contractAddress = this.space.governor;
            let proposalName = this.name;
            if (this.body) proposalName += ';' + this.body;
            this.form.proposalName = proposalName;
            this.form.space = this.space;
            this.form.args = [
                this.selectId,
                this.targets,
                this.values,
                this.signatures,
                this.calldatas,
                proposalName
            ];
            this.form.params = this.form.a;
            this.confirmModalOpen = true;
        }
    }
};
</script>

<style lang="scss">
.list-leave-active,
.list-enter-active {
    transition: all 0.3s;
}
.list-move {
    transition: transform 0.3s;
}
.list-enter,
.list-leave-to {
    opacity: 0;
}
.select-button {
    position: relative;
    .button {
        border-radius: 3px !important;
        width: 100%;
    }
    .select {
        z-index: 9999;
        transition: all 150ms 0ms;
        min-width: 80px;
        box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14),
            0px 3px 14px 2px rgba(0, 0, 0, 0.12);
        position: absolute;
        background-color: #fff;
        border-radius: 8px;
        padding: 10px 15px;
        top: 54px;
        right: 0px;
        .select-item {
            line-height: 30px;
            cursor: pointer;
            &:hover,
            &.active {
                color: #000;
            }
        }
    }
}
</style>
